import Topbar from "./Topbar";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function index(_ref) { let { children } = _ref; return /*#__PURE__*/ _jsxs("div", { style: { width: "100vw", height: "100vh", overflow: "hidden" }, children: [/*#__PURE__*/ _jsx(Topbar, {}), children] }); }
export default index;
